import React from 'react';
import { motion } from 'framer-motion';
import { DownloadIcon, ShieldCheckIcon, ShieldAlertIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="bg-navy text-white pt-14 pb-16 md:pt-32 md:pb-24 px-4 relative overflow-hidden border-b-8 border-safety-red" data-id="element-68">
      {/* Subtle background texture/pattern */}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'radial-gradient(#ffffff 1px, transparent 1px)',
      backgroundSize: '24px 24px'
    }} data-id="element-69"></div>

      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center relative z-10" data-id="element-70">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6
      }} className="flex flex-col space-y-4" data-id="element-71">
          <div className="inline-flex items-center space-x-2 bg-white/10 border border-white/20 px-3 py-1.5 rounded-sm w-fit" data-id="element-72">
            <ShieldAlertIcon className="w-4 h-4 text-safety-red" data-id="element-73" />
            <span className="font-heading text-xs font-bold tracking-widest uppercase text-gray-200" data-id="element-74">
              Family Emergency Preparedness System
            </span>
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold leading-tight" data-id="element-75">
            If the Grid Goes Dark... Does Your Family Have the Map to Survive
            the Next 72 Hours?
          </h1>

          <p className="text-xl md:text-2xl font-body text-gray-300 border-l-4 border-safety-red pl-4" data-id="element-76">
            The Simple 2-Hour System to Protect Your Assets and Medical Records.
          </p>

          <div className="bg-white/10 border border-white/20 px-4 py-3 rounded-sm" data-id="element-77">
            <p className="font-heading text-sm md:text-base font-bold text-white uppercase tracking-wide text-center" data-id="element-78">
              🎁 Order Today &amp; Get{' '}
              <span className="text-yellow-400" data-id="element-79">3 Free Bonuses</span> Included
            </p>
            <p className="font-heading text-xs text-gray-400 uppercase tracking-widest text-center mt-1" data-id="element-80">
              Blackout Guide · Gear Master List · Car Go-Bag Plan
            </p>
          </div>

          <div className="flex flex-col sm:flex-row items-start sm:items-center space-y-4 sm:space-y-0 sm:space-x-4" data-id="element-81">
            <a href="#pricing" className="inline-flex items-center justify-center bg-cta-green hover:bg-green-700 text-white font-heading font-bold text-lg md:text-xl px-8 py-4 rounded-sm transition-colors shadow-lg border border-green-600 uppercase tracking-wide w-full sm:w-auto" data-id="element-82">
              Get The E-Book + 3 Bonuses For $6.39
            </a>
          </div>

          <div className="flex items-center space-x-4 text-sm font-heading text-gray-400 uppercase tracking-wider" data-id="element-83">
            <div className="flex items-center" data-id="element-84">
              <DownloadIcon className="w-4 h-4 mr-1.5" data-id="element-85" />
              Instant Digital Download
            </div>
            <div className="flex items-center" data-id="element-86">
              <ShieldCheckIcon className="w-4 h-4 mr-1.5" data-id="element-87" />
              Secure Checkout
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="relative flex justify-center lg:justify-end items-center" data-id="element-88">
          <img src="https://cdn.magicpatterns.com/uploads/dUar8xh1PxjPBL1q3ZahZp/Prod._2.png" alt="The 72-Hour Family Emergency Binder with digital dashboard on tablet and phone, plus bonus guides: Blackout Survival Guide, Emergency Gear Master List, and Car Go-Bag Plan" className="w-full max-w-lg xl:max-w-xl drop-shadow-2xl" loading="eager" fetchPriority="high" decoding="async" data-id="element-89" />
        </motion.div>
      </div>
    </section>;
}